<template>
   <div class="cont-title">
        <div class="title text-color-primary" :style='{color: styles.color}'>
            <p>{{title}}</p>
        </div>
        <hr class="line-gradiant" :style='{background: styles.gradiant}' >
   </div>
</template>

<script>
export default {
    name: 'Title',
    props:{
        title: {
            type:String,
            default: "Titulo",
            required: true
        },
        styles:{
            type: Object
        }

    }
}
</script>

<style>
.cont-title{
    padding-top: 1.5em;
    padding-bottom: 1.5em;
}
.title{
  text-align: center;
  font-size: 2em;
  width: 95%;
  margin: 0 auto;
}
.line-gradiant{
  background: linear-gradient(to right,transparent,#3A6889,transparent);
  width: 95%;
  margin: 0 auto;
  height: 1px;
  border: 0;
}
</style>